
//export const onevocaUrl = "http://localhost:3000";
export const serverUrl = "https://onevoca.org/onevoca/query";
export const privacyPolicyUrl = "/privacy";
export const termsOfUseUrl = "/terms";
export const profileImageUrl = `${serverUrl}/profile/images/`;
